<!-- Security - Custom Provider-->
<form #customForm="ngForm">
  <div>
    <div class="custom-auth-hint">
      <div class="help-text" [innerHTML]="locale.HINT_CUSTOM_AUTHENTICATION">
      </div>
    </div>
    <div class="form-group app-composite-widget clearfix">
      <label class="control-label app-label col-xs-3 required"
        for="wm-security-custom-class-name">{{locale.LABEL_CLASS_NAME}}: </label>

      <div class="col-xs-9">
        <input name="wm-security-custom-class-name" type="text"
          class="form-control app-textbox wm-security-custom-class-name"
          placeholder="{{locale.LABEL_FULLY_QUAL_CLASS_NAME}}" [(ngModel)]="security.custom.authClassName" />
      </div>
    </div>
  </div>
</form>